import { Component, OnInit, Input, Output, EventEmitter, HostListener, OnChanges, ChangeDetectorRef } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { GridViewModel } from 'src/app/shared/models/sectionview.model';
import { ResponseModel } from 'src/app/shared/models/sectionview.model';
import { QuestionViewModel, Option } from 'src/app/shared/models/questionview.model';

import {
  faPlus,
  faMinus
} from '@fortawesome/free-solid-svg-icons';
import { ButtonColors, ButtonSize, ButtonStyle, ButtonType } from 'src/app/shared/components/inputs/button/button.model';
import { DomSanitizer } from '@angular/platform-browser';
import { ResponseChangeModel } from 'src/app/incident/incident.component';

@Component({
  selector: 'app-inputType-grid',
  templateUrl: './inputType-grid.component.html',
  styleUrls: ['./inputType-grid.component.scss']
,  standalone: false
})
export class InputTypeGridComponent implements OnInit {
  @Input('mainQuestion') gridQuestion: QuestionViewModel;


  //@Input() gridQuestions: GridViewModel;
  @Input() header: ResponseModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() foregroundcolor: string;
  @Input() backgroundcolor: string;
  @Input() theme: string;
  @Input() controlBGColor: string;
  @Input() controlBorder: string;
  @Input() TextColor: string;
  @Input() tableBorder: string;
  @Input() IsReadOnly?: boolean = false;
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  deletedGridResponses : ResponseModel[]=[];
  finalResponses :GridViewModel;

  btnRnd = ButtonType.Round;
  btnPlus = ButtonStyle.PlusIcon;
  btnLarge = ButtonSize.Large;
  btnColor = ButtonColors.Blue;
  maxSequenceNumber: number = 1;
  conditionQues: ConditionalQues[] = [];
  Header: string[];

  constructor(private cdr: ChangeDetectorRef) { }

  removeResponse(rowIndex: number) {

    if (rowIndex !== -1) {
      //change sequence numbers for next response objects and remove selected response
      for (let i = rowIndex + 1; i < this.gridQuestion.responses.length; i++) {
        this.gridQuestion.responses[i].sequenceNumber = this.gridQuestion.responses[i].sequenceNumber - 1;
      }
      this.gridQuestion.responses.splice(rowIndex, 1);
    }
  }
  
  InputChange(value:any){
    this.inputChange.emit(value)
  }

  addNewResponse(gridques: ResponseModel) {
    
    let addResponse = new ResponseModel();
    addResponse.sequenceNumber = this.gridQuestion.responses.length + 1;
    addResponse.questions = [];
    let index = [];
    gridques.questions.forEach(element => {
      index.push(element.questionId);
    });
    let maxindex = 0;

    gridques.questions.forEach(element => {
      let que = new QuestionViewModel();
      que.questionId = index[maxindex];
      que.questionImage = element.questionImage;
      que.parentQuestionId = element.parentQuestionId;
      que.questionImageName = element.questionImageName;
      que.questionText = element.questionText;
      que.questionTextShort = element.questionTextShort;
      que.questionToolTip = element.questionToolTip;
      que.refTableName = element.refTableName;
      que.sectionId = element.sectionId;
      que.sequenceNumber = element.sequenceNumber;
      que.validationDetails = element.validationDetails;
      que.validations = element.validations;
      que.dataType = element.dataType;
      que.defaultResponse = element.defaultResponse;
      // que.inputType="rot";
      que.inputType = element.inputType;
      que.isQuestionRequired = element.isQuestionRequired;
      que.options = [];
      element.options.forEach(elem => {
        let a = new Option;
        a.key = elem.key;
        a.value = elem.value;
        que.options.push(a);
      });


      que.parentQuesResponse = element["parentQuesResponse"];
      // que.responseText = element["responseText"];
      que["initialText"] = element["initialText"];
      que["finalText"] = element["finalText"];
      que["responseText"] = null;
      que.maxLength = element.maxLength;
      maxindex = maxindex + 1;

      addResponse.questions.push(que);
      addResponse.isDefaultControl = false;
    });
    this.gridQuestion.responses.push(addResponse);
    this.gridQuestion.responses.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);
    //this.maxSequenceNumber=this.gridQuestions.response.length;
  }
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['gridQuestion'] && changes['gridQuestion'].currentValue) {
  //     this.gridQuestion = JSON.parse(JSON.stringify(changes['gridQuestion'].currentValue));      
  //     this.cdr.markForCheck();        
  //     this.cdr.detectChanges();
  //     //this.childQuestion.emit(this.gridQuestion);
  //   }
  // }
  ngOnInit() {
    //console.log("response s : ",this.gridQuestions.response);
    console.log('mainQuestion : ', this.gridQuestion);
    this.handleDateQuestions()
  }

  handleDateQuestions() {
    this.gridQuestion.subQuestions.forEach((element) => {
      element.subQuestions.forEach((subElement) => {
        if (subElement.inputType == 'dte') {
          subElement.todayDateEnabled = true;
          subElement.todayDateEnabled = true;
          subElement.pastDateEnabled = true;
        }
      })
    })
  }



  GetChildData(selectedChild: any) {
    // handling validation for grid question
  
    let isValid = true;
    this.gridQuestion.subQuestions.forEach((element, rowIndex) => {
      element.subQuestions.forEach((subElement, columnIndex) => {
        isValid = isValid && subElement['IsValid']!=false;
        if(!isValid){          
          return;
        }
      });
    })

    //Assign latest object to existing object
     if(this.gridQuestion.subQuestions && this.gridQuestion.subQuestions.length > 0){
      this.gridQuestion.subQuestions.forEach(subQ => {
        if(subQ.questionId == selectedChild.questionId){
          Object.assign(subQ, selectedChild);
        }


        if(subQ.subQuestions && subQ.subQuestions.length > 0){
          subQ.subQuestions.forEach(subSubQ => {
            if(subSubQ.questionId == selectedChild.questionId){
              Object.assign(subSubQ, selectedChild);
            }
          });
        }
      });
    }

    this.gridQuestion['IsValid']=isValid;
    this.childQuestion.emit(this.gridQuestion);
  }
  isConditionalCheck(data: ResponseChangeModel) {
    if(data == null || data.question == null){
      return;
    }
    const currQues: QuestionViewModel = data.question;
    const proceedCallback = data.proceed || (() => {});

    if(currQues.inputType === 'mul' || currQues.inputType === 'chk' || currQues.inputType === 'rdo' || currQues.inputType === 'cmb') {
      proceedCallback(true);
    }    
  }
  


toggleSelection(question: QuestionViewModel, option:string,rowIndex:number,columnIndex :number) {
  let selectedOption ='' 
  if(question.responseText==option){
  question.responseText = null;
  selectedOption = null;
  }else{
    question.responseText = option;
    selectedOption = option;
  }
this.gridQuestion.responses[rowIndex].questions[columnIndex].responseText = selectedOption;
this.childQuestion.emit(this.gridQuestion);
}

}
export class ConditionalQues {
  que: string;
  value: string;
  isSelected?: boolean = false;
}